// extracted by mini-css-extract-plugin
module.exports = {"pageRange":"PageRange_pageRange__6JbBn","content":"PageRange_content__xR9JI","divider":"PageRange_divider__6Q5i0","hyperlink":"PageRange_hyperlink__VRzd1"};
module.exports.__checksum = "8182920d562a"
